var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 45,
    viewBox: "0 0 54 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 2.5V32.5M27 32.5L17 22.5M27 32.5L37 22.5M17 7.5H7C5.67392 7.5 4.40215 8.02678 3.46447 8.96447C2.52678 9.90215 2 11.1739 2 12.5V37.5C2 38.8261 2.52678 40.0979 3.46447 41.0355C4.40215 41.9732 5.67392 42.5 7 42.5H47C48.3261 42.5 49.5979 41.9732 50.5355 41.0355C51.4732 40.0979 52 38.8261 52 37.5V12.5C52 11.1739 51.4732 9.90215 50.5355 8.96447C49.5979 8.02678 48.3261 7.5 47 7.5H37",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.76732b28a19d788989b60f2c849efa6b.svg";
export { ForwardRef as ReactComponent };